import type { StoneFinding, StoneLaterality, StoneLocation, StoneVerdict } from "./types";

export function effectiveStone(
  s: StoneFinding,
  edit?: { location?: StoneLocation; laterality?: StoneLaterality },
): StoneFinding {
  if (!edit) return s;
  return {
    ...s,
    location: edit.location ?? s.location,
    laterality: edit.laterality ?? s.laterality,
  };
}

export function computeBurden(stones: StoneFinding[], verdicts: Record<string, StoneVerdict>) {
  let approved = 0,
    denied = 0,
    pending = 0,
    largestMm = 0,
    sumLongAxisMm = 0;
  for (const s of stones) {
    const v = verdicts[s.id] ?? "pending";
    if (v === "approved") {
      approved++;
      sumLongAxisMm += s.measurements.longAxisMm;
    } else if (v === "denied") denied++;
    else pending++;
    largestMm = Math.max(largestMm, s.measurements.longAxisMm);
  }
  return {
    detected: stones.length,
    approved,
    denied,
    pending,
    largestMm: Math.round(largestMm * 10) / 10,
    sumLongAxisMm: Math.round(sumLongAxisMm * 10) / 10,
  };
}
